import { createContext, useContext, useState, useEffect } from 'react';
import { translations, getTranslation } from '../i18n/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first, then user preference
    const saved = localStorage.getItem('bible_buds_language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('bible_buds_language', language);
  }, [language]);

  const t = (key) => getTranslation(language, key);

  const value = {
    language,
    setLanguage,
    t,
    translations: translations[language] || translations['en']
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
